import { resourceFactory, creatOrderFactory } from "@/utils/superpay";

const mapKey = {
  uc: "user_coin",
  is: "image_src",
  ss: "source_scheme",
  fn: "full_name",
  av: "mver",
  pf: "platform", //platform
  pk: "product_kind",
  ak: "appKind",
  un: "username",
  fc: "follow_count",
  lc: "like_count",
  vc: "view_count",
  cc: "comment_count",
  uj: "user_info", //user_info
  tj: "feed_data", //feed_data
  oi: "offer_id", //offer_id
  ru: "redirect_url"
};

export const objectToString = data => {
  if (typeof data === "object") {
    return JSON.stringify(data);
  } else if (typeof data === "string") {
    return data;
  } else {
    return data.toString();
  }
};

export const jumpWebPayPalQueryFactory = offer => {
  const postOfferData = creatOrderFactory(offer);
  const newArray = [];

  for (const key in postOfferData) {
    for (const map in mapKey) {
      if (mapKey[map] === key) {
        newArray.push(
          `${map}=${encodeURIComponent(objectToString(postOfferData[key]))}`
        );
      }
    }
  }

  //添加redirect_url:
  newArray.push(
    `ru=${window.location.origin}/paymentResult?paypal_result=`
  );

  console.log("newArray:", newArray);

  return newArray.join("&");
};



// WEBPACK FOOTER //
// ./src/service/paypal.js